import React from 'react'

import './style.scss'

const FilterRadio = ({ text, id, onChangeHandler, isActive }) => {
    return <span id={id} className={isActive !== null && isActive !== undefined && isActive === id ? 'filter-radio active' : 'filter-radio'} onClick={onChangeHandler}>{text}</span>
}

export default FilterRadio